export const buildNumber = '20260508.8';
export const version = 'main';
export const latestCommit = '41731045549ebb8b6d8e3c898761b52d88a2a7a6';
